import type { Bounds } from 'quill/core';

function getRelativeBoundingRect(element: Element, container: Element): Bounds {
  const rect = element.getBoundingClientRect();
  const { left: x, top: y } = container.getBoundingClientRect();

  return {
    width: rect.width,
    height: rect.height,
    top: rect.top - y,
    right: rect.right - x,
    bottom: rect.bottom - y,
    left: rect.left - x,
  };
}

export default getRelativeBoundingRect;
